import React, { useState, useMemo } from "react"
import PropTypes from "prop-types"
import CustomLink from "./custom-link"

const Navigation = ({ lang = "de", path, navTheme = "light" }) => {
  const navMenu = require("../data/navigation.json")
  const [state, setState] = useState([1, 0])

  const mouseDownHandle = selectedLang => {
    localStorage.setItem("senses-integration-language", selectedLang)
  }

  return useMemo(
    () => (
      <>
        <input
          type="radio"
          name={`navigation-${lang}-${path}`}
          readOnly
          checked={navTheme === "light"}
        />
        <input
          type="radio"
          name={`navigation-${lang}-${path}`}
          readOnly
          checked={navTheme === "dark"}
        />
        <nav className="main-nav">
          <div className="nav-logo">
            <CustomLink to={`/${lang === "de" ? "" : lang}`} path={path}>
              <img
                src="/assets/svg/senses-integration_Logo_black.svg"
                alt="Sense Integration Logo"
              />
              <img
                src="/assets/svg/senses-integration_Logo_white.svg"
                alt="Sense Integration Logo"
              />
            </CustomLink>
          </div>
          <div className={lang === "cn" ? "main-menu cn-lang" : "main-menu"}>
            <div
              className={
                state[1]
                  ? "main-menu-wrapper opacity-100"
                  : "main-menu-wrapper opacity-0"
              }
            >
              <div className="nav-logo">
                <CustomLink to={`/${lang === "de" ? "" : lang}`} path={path}>
                  <img
                    src="/assets/svg/senses-integration_Logo_white.svg"
                    alt="Sense Integration Logo"
                  />
                </CustomLink>
              </div>
              <div className="menu-item">
                <div className="item">
                  <CustomLink
                    to={`${lang !== "de" ? "/" + lang : ""}/about`}
                    path={path}
                  >
                    {navMenu[lang][0]}
                  </CustomLink>
                </div>
              </div>
              <div className="menu-item">
                <div className="item">
                  <CustomLink
                    to={lang === "de" ? "/kontakt" : `/${lang}/contact`}
                    path={path}
                  >
                    {navMenu[lang][1]}
                  </CustomLink>
                </div>
              </div>
              <div className="menu-item">
                <div className="item">
                  <CustomLink
                    to={lang === "de" ? "/prozess" : `/${lang}/process`}
                    path={path}
                  >
                    {navMenu[lang][2]}
                  </CustomLink>
                </div>
              </div>
            </div>
          </div>
          <div className="nav-buttons z-10">
            <button
              className={
                state[0]
                  ? "btn visible opacity-100 transition ease-in-out duration-700"
                  : "btn hidden invisible opacity-0"
              }
              onClick={() => setState([0, 1])}
            >
              <img
                src="/assets/svg/menu-black-48dp.svg"
                alt="Main Menu Toggle"
              />
              <img
                src="/assets/svg/menu-white-48dp.svg"
                alt="Main Menu Toggle"
              />
            </button>
            <button
              className={
                state[1]
                  ? "btn visible opacity-100 self-end transition ease-in-out duration-700"
                  : "btn hidden self-end invisible opacity-0"
              }
              onClick={() => setState([1, 0])}
            >
              <img
                src="/assets/svg/close-white-48dp.svg"
                alt="Close Menu Modal"
              />
            </button>
            <ul
              className={
                state[1]
                  ? `visible opacity-100 self-end transition ease-in-out duration-700${
                      /\/information/g.test(path) ? " pointer-events-none" : ""
                    }`
                  : "hidden self-end invisible opacity-0"
              }
            >
              <li
                className={lang === "cn" ? "list-disc font-bold" : "list-none"}
              >
                <CustomLink
                  to={
                    /\/kontakt$/.test(path)
                      ? `/cn/contact`
                      : /\/prozess$/.test(path)
                      ? "/cn/process"
                      : `/cn${path.replace(/^\/((cn)|(en))/, "")}`
                  }
                  path={path}
                >
                  <button
                    className="btn"
                    onMouseDown={() => mouseDownHandle("cn")}
                  >
                    CN
                  </button>
                </CustomLink>
              </li>
              <li
                className={lang === "de" ? "list-disc font-bold" : "list-none"}
              >
                <CustomLink
                  to={
                    path.length > 3
                      ? /\/process$/.test(path)
                        ? "/prozess"
                        : /\/contact$/.test(path)
                        ? "/kontakt"
                        : path.replace(/^\/((cn)|(en))/, "")
                      : path.replace(/^\/((cn)|(en))/, "/")
                  }
                  path={path}
                >
                  <button
                    className="btn"
                    onMouseDown={() => mouseDownHandle("de")}
                  >
                    DE
                  </button>
                </CustomLink>
              </li>
              <li
                className={lang === "en" ? "list-disc font-bold" : "list-none"}
              >
                <CustomLink
                  to={
                    /\/kontakt$/.test(path)
                      ? `/en/contact`
                      : /\/prozess$/.test(path)
                      ? "/en/process"
                      : `/en${path.replace(/^\/((cn)|(en))/, "")}`
                  }
                  path={path}
                >
                  <button
                    className="btn"
                    onMouseDown={() => mouseDownHandle("en")}
                  >
                    EN
                  </button>
                </CustomLink>
              </li>
            </ul>
          </div>
        </nav>
      </>
    ),
    [state, navTheme]
  )
}

Navigation.propTypes = {
  path: PropTypes.string,
  lang: PropTypes.string,
  width: PropTypes.number,
  navTheme: PropTypes.string,
}

export default Navigation
